import { render, staticRenderFns } from "./loginPassPhrase.vue?vue&type=template&id=effa9888&"
import script from "./loginPassPhrase.vue?vue&type=script&lang=js&"
export * from "./loginPassPhrase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports